module.exports = __webpack_public_path__ + "img/login_right.4aee32fc.svg";